export default "__VITE_ASSET__HBF_h$dQ__"